export default __webpack_public_path__ + "static/media/animal.67da41fa.png";